import FacilityInfo from "@/views/reporting/RecyclingActivities/FacilityInfo.vue";
import Materials from "@/views/reporting/RecyclingActivities/Materials.vue";

export default {
    FacilityInfo,
    Materials
}